/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const StatsBox: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="stats-box" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M1076.6666666666665 1190C1139 1190 1190 1139 1190 1076.6666666666667V283.3333333333335C1190 221 1139 170 1076.6666666666665 170H170V1076.6666666666667C170 1139 221 1190 283.3333333333333 1190H1076.6666666666665zM283.3333333333333 1076.6666666666667V283.3333333333335H1076.6666666666665V1076.6666666666667H283.3333333333333zM510 396.6666666666668H396.6666666666667V793.3333333333334H510V396.6666666666668zM736.6666666666666 396.6666666666668H623.3333333333333V963.3333333333334H736.6666666666666V396.6666666666668zM963.3333333333331 396.6666666666668H850V623.3333333333334H963.3333333333331V396.6666666666668z" : "M861.3333333333334 952C911.2000000000002 952 952 911.2 952 861.3333333333333V226.6666666666667C952 176.7999999999999 911.2000000000002 136 861.3333333333334 136H136V861.3333333333333C136 911.2 176.8 952 226.6666666666667 952H861.3333333333334zM226.6666666666667 861.3333333333333V226.6666666666667H861.3333333333334V861.3333333333333H226.6666666666667zM408 317.3333333333333H317.3333333333334V634.6666666666666H408V317.3333333333333zM589.3333333333334 317.3333333333333H498.6666666666667V770.6666666666666H589.3333333333334V317.3333333333333zM770.6666666666667 317.3333333333333H680V498.6666666666666H770.6666666666667V317.3333333333333z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
StatsBox.displayName = `Blueprint5.Icon.StatsBox`;
export default StatsBox;
